/*
*   Add workaround for mobile course menu.
*   Unfortunately the loading overlay requires jQuery
*
*   @author <mario.sassmann@speedy-space.com>
*/
( function ( $ ) {

    const course_timeline_anchors = document.querySelectorAll( '.course_timeline-custom ol li a' );
    for ( const a of course_timeline_anchors) {
        a.addEventListener( 'click', function ( ev ) {
            ev.preventDefault();

            showProgressAnimation();
            window.location.href = this.href;
        } );
    }

    const course_timeline = document.querySelector( '.course_timeline-custom' );
    if ( course_timeline ) {
        course_timeline.addEventListener( 'click', ( ev ) => {
            ev.stopPropagation();
        } );

        course_timeline.addEventListener( 'touchstart', ( ev ) => {
            ev.stopPropagation();
        } );

        course_timeline.addEventListener( 'touchend', ( ev ) => {
            ev.stopPropagation();
        } );
    }

    // prevent the menu from closing, allow scrolling on mobile devices
    const course_timeline_items = document.querySelectorAll( '.course_timeline-custom ol li' );
    for ( const item of course_timeline_items ) {
        item.addEventListener( 'click', ( ev ) => {
            ev.stopPropagation();
        } );

        item.addEventListener( 'touchstart', ( ev ) => {
           ev.stopPropagation();
        } );

        item.addEventListener( 'touchend', ( ev ) => {
            ev.stopPropagation();
        } );
    }

    function showProgressAnimation() {
        course_timeline.style.display = 'block';

        // if LoadingOverlay is available, use it
        if ( $.fn.LoadingOverlay ) {
            $.LoadingOverlay( 'show', {
                imageColor: '#2bb8bc'
            } );
        }
    }

} ) ( jQuery );
